"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var theme_1 = __importDefault(require("../../../styles/theme"));
var makeStyles_1 = __importDefault(require("../../../util/makeStyles"));
var styleUtilities_1 = require("../../../util/styleUtilities");
var makeAlertMessageStyle = function (maxHeight) {
    return (0, makeStyles_1.default)(function () {
        return (0, core_1.createStyles)({
            root: {
                backgroundColor: (0, styleUtilities_1.withOpacity)(theme_1.default.colors.error, 0.08),
                borderRadius: 4,
                display: 'grid',
                gap: 16,
                gridTemplateColumns: '24px auto fit-content(100%)',
                maxHeight: maxHeight,
                minHeight: 48,
                overflowY: 'auto',
                padding: '12px 16px',
                width: '100%',
            },
            rootWithoutAction: {
                gridTemplateColumns: '24px auto',
            },
            warning: {
                backgroundColor: theme_1.default.colors.warningLight,
            },
            info: {
                backgroundColor: (0, styleUtilities_1.withOpacity)(theme_1.default.colors.primaryLight, 0.5),
            },
            flexContainer: {
                display: 'flex',
                alignItems: 'center',
            },
            copyIcon: {
                cursor: 'pointer',
            },
            titleContainer: {
                paddingBottom: 4,
            },
            maxHeight: {
                maxHeight: maxHeight - 2 * 12,
                top: 0,
                position: 'sticky',
            },
        });
    })();
};
exports.default = makeAlertMessageStyle;
